import React,{useContext} from 'react'
import styled from 'styled-components'
import { SalleContext } from '../../context/salle'


const CardWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    width: 90%;
    min-height: 90px;
    margin-top: 1rem;

`
const Box = styled.div`
`
const Row = styled.div`

    display:flex;
    justify-content: space-between;

    .remove_space{
        height: 15px;
    }


`
const BoxText = styled.div`
    margin-bottom: 1.2rem;
    height:2rem;
    min-width: 220px;

    p{
        font-size: 0.9rem;
        font-family: "Poppins";
        font-weight: 500;
        height: 0.2rem;
    }

    .textPrimary{
        max-width: 220px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        height: auto;
        font-size: 1rem;
        font-family: "Poppins";
        font-weight: 600;
    }


`
const Line = styled.div`

    display:flex;
    align-items: center;
    
    div{
        margin-right: 0rem;
    }

`
const HeaderCard = styled.div`
    display:flex;
    justify-content: space-between;

`

const Button = styled.button`

`




const CardDataModalTiny = ({ textPrimary, textSecondary }) => {
    const {products} = useContext(SalleContext)

    const total = Number(products[0]?.price) * Number(products[0].quantity) 
    

    return (
        <CardWrapper>
            <Row>
                <Box>
    
                    <Line>
                    <BoxText>
                        <p>Descrição</p>
                        <p className='textPrimary'>{products[0]?.name_product}</p>
                        
                    </BoxText>
                    <Line>
                    <BoxText>
                        <p></p>
                        <p className='textPrimary'></p>
                        
                    </BoxText>
                    <BoxText>
                        <p>Código (SKU)</p>
                        <p className='textPrimary'>{products[0]?.sku}</p>
                        
                    </BoxText>
                    </Line>

                    </Line>
                    <Line>
                    <BoxText>
                        <p>Quantidade</p>
                        <p className='textPrimary'>{products[0]?.quantity}</p>
                        
                    </BoxText>
                    <Line>
                    <BoxText>
                        <p>Unidade</p>
                        <p className='textPrimary'>{products[0]?.quantity}</p>
                        
                    </BoxText>
                    <BoxText>
                        <p>Preço lista</p>
                        <p className='textPrimary'>{Number(products[0]?.price).toLocaleString("pt-BR",{minimumFractionDigits:2})}</p>
                        
                    </BoxText>
                    
                    </Line>

    
               
                    </Line>
                    <Line>
                    <BoxText>
                        <p>Preço unitário</p>
                        <p className='textPrimary'>{Number(products[0]?.price).toLocaleString("pt-BR",{minimumFractionDigits:2})}</p>
                        
                    </BoxText>
                    <Line>
                    <BoxText>
                        <p>Preço total</p>
                        <p className='textPrimary'>{Number(total).toLocaleString("pt-BR",{minimumFractionDigits:2})}</p>
                        
                    </BoxText>

                    
                    </Line>

    
               
                    </Line>
                </Box>
            </Row>
    

        </CardWrapper>
    )
}

export default CardDataModalTiny